const CodeEMeasurements = () => {
  return (
    <svg
      width="120"
      height="104"
      viewBox="0 0 120 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.8563 103.532H11.042C5.45209 103.532 0.916016 100.065 0.916016 95.8018V93.2252H44.9022V103.532H44.8563Z"
        fill="#E6E6E6"
      />
      <path
        d="M45.315 17.8017H22.7263C15.9451 17.8017 10.4927 23.3765 10.4927 29.8414L10.9967 89.4774H20.1146L20.6187 29.5134H45.315V17.8017Z"
        fill="#E6E6E6"
      />
      <path
        d="M43.0239 41.6937H30.6528V58.5586H43.0239V41.6937Z"
        fill="#E6E6E6"
      />
      <path
        d="M43.9403 103.531H10.8591C4.8568 103.531 0 98.5657 0 92.4288V88.5405H42.6116V89.9459H1.37457V92.4288C1.37457 97.7693 5.63573 102.126 10.8591 102.126H43.9861V103.531H43.9403Z"
        fill="#808080"
      />
      <path
        d="M44.3989 89.9459H10.0347V30.6378C10.0347 23.5639 15.6704 17.8017 22.5891 17.8017H44.3989V19.2071H22.5891C16.4035 19.2071 11.4092 24.3603 11.4092 30.6378V88.5405H44.3989V89.9459Z"
        fill="#808080"
      />
      <path
        d="M4.53619 38.8829H3.16162V30.3099C3.16162 19.3009 11.913 10.3063 22.7263 10.3063H37.5258V11.7117H22.7263C12.692 11.7117 4.53619 20.0505 4.53619 30.3099V38.8829Z"
        fill="#808080"
      />
      <path
        d="M120 104H48.0645V0H99.5649L120 18.1766V104ZM49.439 102.595H118.626V18.8324L99.0609 1.40541H49.439V102.595Z"
        fill="#808080"
      />
      <path
        d="M109.003 34.6667H59.9771V36.0721H109.003V34.6667Z"
        fill="#808080"
      />
      <path
        d="M95.2118 17.2829H59.9771V18.6883H95.2118V17.2829Z"
        fill="#808080"
      />
      <path
        d="M109.003 42.6306H59.9771V44.036H109.003V42.6306Z"
        fill="#808080"
      />
      <path
        d="M109.003 25.2467H59.9771V26.6521H109.003V25.2467Z"
        fill="#808080"
      />
      <path
        d="M77.8462 52.4684H60.4351V70.2702H77.8462V52.4684Z"
        fill="#E6E6E6"
      />
      <path
        d="M109.003 52.0001H84.2612V53.4055H109.003V52.0001Z"
        fill="#808080"
      />
      <path
        d="M99.8397 60.4324H84.2612V61.8378H99.8397V60.4324Z"
        fill="#808080"
      />
      <path
        d="M98.4651 69.8018H84.2612V71.2072H98.4651V69.8018Z"
        fill="#808080"
      />
      <path
        d="M110.378 89.9459H59.0605V79.1711H110.378V89.9459ZM60.4351 88.5405H109.003V80.5765H60.4351V88.5405Z"
        fill="#808080"
      />
      <path
        d="M118.167 19.2072H98.9233V0.936981H100.298V17.8018H118.167V19.2072Z"
        fill="#808080"
      />
      <path
        d="M20.5728 87.135H19.1982V29.0449H43.9405V30.4503H20.5728V87.135Z"
        fill="#808080"
      />
      <path
        d="M42.5659 67.9279H30.1948V69.3333H42.5659V67.9279Z"
        fill="#808080"
      />
      <path
        d="M42.5659 76.3604H30.1948V77.7658H42.5659V76.3604Z"
        fill="#808080"
      />
      <path
        d="M41.6497 59.027H29.7368V40.7567H41.6497V42.1621H31.1114V57.6216H41.6497V59.027Z"
        fill="#808080"
      />
      <path
        d="M109.003 60.4324H105.338V61.8378H109.003V60.4324Z"
        fill="#808080"
      />
      <path
        d="M4.53619 42.6306H3.16162V81.9315H4.53619V42.6306Z"
        fill="#808080"
      />
    </svg>
  );
};
export default CodeEMeasurements;
